export function isExternal(path) {
    return /^(https?:|mailto:|tel:)/.test(path)
  }
  


// WEBPACK FOOTER //
// ./src/utils/index.js